import Utils from 'common/services/Utils';
import { RegisterOptions } from 'react-hook-form';

/**
 * Languages
 */
export const DEFAULT_LANGUAGE = 'fr';
export const DEFAULTNS = 'translations';

/**
 * API
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const SERVER_BASE_URL = process.env.REACT_APP_SERVER_URL;

/**
 * APP STORES URLS
 */
export const GOOGLE_STORE_APP_URL = 'https://play.google.com/store/apps/details?id=com.fleetmax&pcampaignid=web_share';
export const APPLE_STORE_APP_URL = 'https://apps.apple.com/br/app/fleetmax/id1601206020';
/**
 * Storage
 */
export const STORAGE_KEY = 'cQfTjWnZr4u7x!A%D*G-KaNdRgUkXp2s';
export const STORAGE = {
    CURRENT_LOCALE: 'CURRENT_LOCALE',
    AUTH_USER_TOKEN: 'AUTH_USER_TOKEN',
    AUTH_USER_PROFILE: 'AUTH_USER_PROFILE',
};

/**
* GA
*/
export const GA = process.env.REACT_APP_GA;

/**
 * Logger
 */
export enum LOGGER_MESSAGE_TYPE {
    INFO = 1,
    ERROR,
}
export enum LOGGER_LOG_TYPE {
    REQUEST,
    APP_CRASH,
    VEHICLES,
    USE_CONTRACTS,
    MAINTENANCE_CONTRACTS,
    INSURANCE_CONTRACTS,
    CONTRACTS,
    CHARGES,
    IMPORT_CHARGES,
    MAINTENANCES,
    ACCIDENTS,
    DRIVERS,
    ALERTS,
    VERIFICATIONS,
    DASHBOARD,
    ALARMS,
    GEOFENCES,
    VEHICLES_GPS,
    REMINDERS
}
export const LOGGER_PRINT_LOGS = process.env.REACT_APP_LOGGER_PRINT_LOGS || false;
export const LOGGER_PRINT_LOGS_LEVEL = LOGGER_MESSAGE_TYPE.INFO;
export const LOGGER_SEND_LOGS = process.env.REACT_APP_LOGGER_SEND_LOGS || false;
export const LOGGER_SEND_LOGS_LEVEL = LOGGER_MESSAGE_TYPE.ERROR;
export const LOGGER_KEYS = process.env.REACT_APP_LOGGER_KEYS ?? '';
export const LOGGER_URL = process.env.REACT_APP_LOGGER_URL ?? '';

/**
 * DATE FORMAT
 */
export const DATE_FORMAT_DEFAUT = 'DD/MM/YYYY';
export const DATEPICKER_FORMAT_DEFAULT = 'dd/MM/yyyy';
export const DATE_TIME_FORMAT_DEFAUT = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_MONTH_YEAR = 'MM/YYYY';
export const DATE_TIME_FORMAT_DEFAULT = 'DD/MM/YYYY | HH:mm';
export const DATE_FORMAT_MONTH_TEXT_YEAR = 'MMM/YYYY';
export const TIME_FORMAT_DEFAULT = 'HH:mm';


/**
 * NUMBERS
 */
export const NUMBERS_MAX_LENGTH = 14;
export const NUMBERS_MAX_VALUE = 999999999.99;

/**
 * POLICIES
 */
export const POLICIES = {
    SETTINGUP_COMPANIES_READ: 'SETTINGUP_COMPANIES_READ',
    SETTINGUP_COMPANIES_WRITE: 'SETTINGUP_COMPANIES_WRITE',
    SETTINGUP_MY_COMPANY_WRITE: 'SETTINGUP_MY_COMPANY_WRITE',
    SETTINGUP_USERS_READ: 'SETTINGUP_USERS_READ',
    SETTINGUP_USERS_WRITE: 'SETTINGUP_USERS_WRITE',
    SETTINGUP_ROLES_READ: 'SETTINGUP_ROLES_READ',
    SETTINGUP_ROLES_WRITE: 'SETTINGUP_ROLES_WRITE',
    SETTINGUP_RULES_READ: 'SETTINGUP_RULES_READ',
    SETTINGUP_RULES_WRITE: 'SETTINGUP_RULES_WRITE',
    SETTINGUP_VEHICLES_READ: 'SETTINGUP_VEHICLES_READ',
    SETTINGUP_VEHICLES_WRITE: 'SETTINGUP_VEHICLES_WRITE',
    SETTINGUP_VEHICLE_SEGMENTS_READ: 'SETTINGUP_VEHICLE_SEGMENTS_READ',
    SETTINGUP_VEHICLE_SEGMENTS_WRITE: 'SETTINGUP_VEHICLE_SEGMENTS_WRITE',
    SETTINGUP_VEHICLE_BRANDS_READ: 'SETTINGUP_VEHICLE_BRANDS_READ',
    SETTINGUP_VEHICLE_BRANDS_WRITE: 'SETTINGUP_VEHICLE_BRANDS_WRITE',
    SETTINGUP_VEHICLE_MODELS_READ: 'SETTINGUP_VEHICLE_MODELS_READ',
    SETTINGUP_VEHICLE_MODELS_WRITE: 'SETTINGUP_VEHICLE_MODELS_WRITE',
    SETTINGUP_SUPPLIERS_READ: 'SETTINGUP_SUPPLIERS_READ',
    SETTINGUP_SUPPLIERS_WRITE: 'SETTINGUP_SUPPLIERS_WRITE',
    SETTINGUP_GENERIC_TYPES_READ: 'SETTINGUP_GENERIC_TYPES_READ',
    SETTINGUP_GENERIC_TYPES_WRITE: 'SETTINGUP_GENERIC_TYPES_WRITE',
    SETTINGUP_LOCALS_READ: 'SETTINGUP_LOCALS_READ',
    SETTINGUP_LOCALS_WRITE: 'SETTINGUP_LOCALS_WRITE',
    SETTINGUP_API_TOKENS_READ: 'SETTINGUP_API_TOKENS_READ',
    SETTINGUP_API_TOKENS_WRITE: 'SETTINGUP_API_TOKENS_WRITE',
    SETTINGUP_DIAGNOSTIC_TYPES_READ: 'SETTINGUP_DIAGNOSTIC_TYPES_READ',
    SETTINGUP_DIAGNOSTIC_TYPES_WRITE: 'SETTINGUP_DIAGNOSTIC_TYPES_WRITE',
    SETTINGUP_DRIVERS_READ: 'SETTINGUP_DRIVERS_READ',
    SETTINGUP_ALERTS_READ: 'SETTINGUP_ALERTS_READ',
    SETTINGUP_VERIFICATIONS_READ: 'SETTINGUP_VERIFICATIONS_READ',
    SETTINGUP_VERIFICATIONS_WRITE: 'SETTINGUP_VERIFICATIONS_WRITE',
    SETTINGUP_ANNOTATIONS_WRITE: 'SETTINGUP_ANNOTATIONS_WRITE',
    SETTINGUP_VEHICLE_MAINTENANCES_READ: 'SETTINGUP_VEHICLE_MAINTENANCES_READ',
    SETTINGUP_VEHICLE_MAINTENANCES_WRITE: 'SETTINGUP_VEHICLE_MAINTENANCES_WRITE',
    SETTINGUP_CHARGES_READ: 'SETTINGUP_CHARGES_READ',
    SETTINGUP_CHARGES_WRITE: 'SETTINGUP_CHARGES_WRITE',
    SETTINGUP_CONTRACTS_READ: 'SETTINGUP_CONTRACTS_READ',
    SETTINGUP_CONTRACTS_WRITE: 'SETTINGUP_CONTRACTS_WRITE',
    SETTINGUP_ACCIDENTS_READ: 'SETTINGUP_ACCIDENTS_READ',
    SETTINGUP_ACCIDENTS_WRITE: 'SETTINGUP_ACCIDENTS_WRITE',
    SETTINGUP_GPS_READ: 'SETTINGUP_GPS_READ',
    SETTINGUP_GPS_WRITE: 'SETTINGUP_GPS_WRITE',
    SETTINGUP_GPS_KMS_READ: 'SETTINGUP_GPS_KMS_READ',
    SETTINGUP_ECO_DRIVING_READ: 'SETTINGUP_ECO_DRIVING_READ',
    SETTINGUP_ASSET_ECO_DRIVING_READ: 'SETTINGUP_ASSET_ECO_DRIVING_READ',
    CHARGES_TOTAL_READ: 'CHARGES_TOTAL_READ',
    SETTINGUP_VEHICLES_MANAGEMENT_READ: 'SETTINGUP_VEHICLES_MANAGEMENT_READ',
    SETTINGUP_VEHICLES_MANAGEMENT_WRITE: 'SETTINGUP_VEHICLES_MANAGEMENT_WRITE',
    SETTINGUP_VEHICLES_MILEAGE_READ: 'SETTINGUP_VEHICLES_MILEAGE_READ',
    SETTINGUP_VEHICLES_MILEAGE_WRITE: 'SETTINGUP_VEHICLES_MILEAGE_WRITE',
    SETTINGUP_COMMUNICATIONS_READ: 'SETTINGUP_COMMUNICATIONS_READ',
    SETTINGUP_COMMUNICATIONS_WRITE: 'SETTINGUP_COMMUNICATIONS_WRITE',
    SETTINGUP_RESERVATIONS_READ: 'SETTINGUP_RESERVATIONS_READ',
    SETTINGUP_RESERVATIONS_WRITE: 'SETTINGUP_RESERVATIONS_WRITE',
    SETTINGUP_RESERVATIONS_EDIT_ALL: 'SETTINGUP_RESERVATIONS_EDIT_ALL',
    SETTINGUP_RESERVATIONS_APPROVE: 'SETTINGUP_RESERVATIONS_APPROVE',
    SETTINGUP_NOTIFICATIONS_READ: 'SETTINGUP_COMMUNICATIONS_READ',
    SETTINGUP_NOTIFICATIONS_WRITE: 'SETTINGUP_COMMUNICATIONS_WRITE',
    SETTINGUP_REFUND_READ: 'SETTINGUP_REFUND_READ',
    SETTINGUP_REFUND_STATUS_WRITE: 'SETTINGUP_REFUND_STATUS_WRITE',
    SETTINGUP_REFUND_SITUATION_WRITE: 'SETTINGUP_REFUND_SITUATION_WRITE',
    SETTINGUP_DASHBOARDS_READ: 'SETTINGUP_DASHBOARDS_READ',
    SETTINGUP_IMPORT_EXPENSES_WRITE: 'SETTINGUP_IMPORT_EXPENSES_WRITE',
    SETTINGUP_REQUEST_VERIFICATIONS_WRITE: 'SETTINGUP_REQUEST_VERIFICATIONS_WRITE',
    SETTINGUP_IMPORT_DATA_WRITE: 'SETTINGUP_IMPORT_DATA_WRITE',
    SETTINGUP_EXPORT_EXPENSES_WRITE: 'SETTINGUP_EXPORT_EXPENSES_WRITE',
    SETTINGUP_EXPORT_LISTING_WRITE: 'SETTINGUP_EXPORT_LISTING_WRITE',
    SETTINGUP_MOBILE_SEE_ONLY_RESERVE_VEHICLES: 'SETTINGUP_MOBILE_SEE_ONLY_RESERVE_VEHICLES',
    SETTINGUP_REMINDER_CATEGORIES_READ: 'SETTINGUP_REMINDER_CATEGORIES_READ',
    SETTINGUP_REMINDER_CATEGORIES_WRITE: 'SETTINGUP_REMINDER_CATEGORIES_WRITE',
    SETTINGUP_REMINDER_READ: 'SETTINGUP_REMINDER_READ',
    SETTINGUP_REMINDER_WRITE: 'SETTINGUP_REMINDER_WRITE',
    SETTINGUP_COST_CENTER_READ: 'SETTINGUP_COST_CENTER_READ',
    SETTINGUP_COST_CENTER_WRITE: 'SETTINGUP_COST_CENTER_WRITE',
    SETTINGUP_IDENTIFICATION_TAGS_READ: 'SETTINGUP_IDENTIFICATION_TAGS_READ',
    SETTINGUP_IDENTIFICATION_TAGS_WRITE: 'SETTINGUP_IDENTIFICATION_TAGS_WRITE',
    SETTINGUP_PRIVACY_STATUS_READ: 'SETTINGUP_PRIVACY_STATUS_READ'
};

/**
 * ROLES
 */
export const ROLES = {
    PLATFORM_ADMINISTRATOR: 'PLATFORM_ADMINISTRATOR',
    ADMINISTRATOR: 'ADMINISTRATOR',
    CONTRIBUTOR: 'CONTRIBUTOR'
};

/**
 * Pagination
 */
export const DEFAULT_PAGINATION_ITEMS_PER_PAGE = 10;
export const MAX_PAGINATION_ITEMS_PER_PAGE = 999999;

/**
 * MIMETYPES
 */
export const MIMETYPES_IMAGE = 'image/png, image/gif, image/jpeg';
export const MIMETYPES_ALL_IMAGE = 'image/*';

export const isTablet = (width: number) => {
    return (width <= 1200);
}

export const removeAccents = (str: string) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export const blobToBase64 = (blobFile: Blob): Promise<string> => {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve((reader.result) as string);
        };
        reader.readAsDataURL(blobFile);
    });
}

export const blobToText = (blobFile: Blob): Promise<string> => {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve((reader.result) as string);
        };
        reader.readAsText(blobFile);
    });
}

export const urlToBase64 = (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
            blobToBase64(xhr.response).then(resolve).catch(reject);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.withCredentials = true;
        xhr.send();
    });
}

export const googleMapsQuery = (latitude?: number, longitude?: number): string => {
    return `https://www.google.com/maps/search/?api=1&query=${latitude ?? 0},${longitude ?? 0}`;
}

export const DEFAULT_INPUT_RULES: RegisterOptions = { minLength: 1, maxLength: 255 }
export const DEFAULT_INPUT_RULES_WITH_REQUIRED: RegisterOptions = { required: true, validate: value => !Utils.isStringNullOrEmpty(value), ...DEFAULT_INPUT_RULES }
export const DEFAULT_EMAIL_RULES: RegisterOptions = { ...DEFAULT_INPUT_RULES, pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/, message: 'common.errors.email_not_valid' } }
export const DEFAULT_EMAIL_RULES_WITH_REQUIRED: RegisterOptions = { required: true, validate: value => !Utils.isStringNullOrEmpty(value), ...DEFAULT_EMAIL_RULES }

export const FUELS = {
    HYBRID: 'HYBRID',
    ELECTRIC: 'ELECTRIC',
    GASEOUS_FUEL: 'GASEOUS_FUEL',
    GASOLINE: 'GASOLINE',
    DIESEL: 'DIESEL'
};

export const COUNTRIES = {
    PT: 'PT',
    FR: 'FR'
};

export const TOKEN_TYPES = {
    RESET_PASSWORD: 'resetPassword'
};


export const ApplicationName = 'FleetMax';

export const QueryParameterNames = {
    ReturnUrl: 'returnUrl',
    Message: 'message'
};

export const LogoutActions = {
    LogoutCallback: 'logout-callback',
    Logout: 'logout',
    LoggedOut: 'logged-out'
};

export const LoginActions = {
    Login: 'login',
    LoginCallback: 'login-callback',
    LoginFailed: 'login-failed',
    Profile: 'profile',
    Register: 'register',
    Reset: 'resetPassword'
};

const prefix = '/authentication';

export const ApplicationPaths = {
    DefaultLoginRedirectPath: '/',
    ApiAuthorizationClientConfigurationUrl: `${SERVER_BASE_URL}/_configuration/${ApplicationName}`,
    ApiAuthorizationPrefix: prefix,
    Login: `${prefix}/${LoginActions.Login}`,
    LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
    LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
    Register: `${prefix}/${LoginActions.Register}`,
    Profile: `${prefix}/${LoginActions.Profile}`,
    LogOut: `${prefix}/${LogoutActions.Logout}`,
    LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
    LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
    IdentityRegisterPath: 'Identity/Account/Register',
    IdentityManagePath: 'Identity/Account/Manage',
    IdentityTwoFactorAuthenticationPath: `${SERVER_BASE_URL}/Identity/Account/Manage/TwoFactorAuthentication`,
    Reset: `${prefix}/${LoginActions.Reset}`
};

export const DASHBOARD_COLORS = {
    expenses: {
        ASSURANCE: '#68D9F3',
        CONTRACTS: '#E2B434',
        MAINTENANCES: '#0cb6d1',
        COSTS: '#1781A1',
        FINES: '#dc4c4c',
        FUEL: '#16E0CC',
        ENERGY: '#02c7c7',
        CLEANING: '#56cf76',
        ACCESSORIES: '#3a9fbf',
        LOGO: '#2d6b8a',
        TRANSPORT: '#66999B',
        MISCELLANEOUS: '#996633',
    },
    consumes: {
        AVERAGE: '#1781A1',
        FUEL: '#1781A1',
        ENERGY: '#16DDCB',
    },
    monthlyCost: {
        FIXED_COST: '#02c7c7',
        VARIABLE_COST: '#038cb6',
    },
    fuels: {
        GASOLINE: '#68D9F3',
        GASEOUS_FUEL: '#E2B434',
        ELECTRIC: '#0cb6d1',
        DIESEL: '#1781A1',
    },
    monthlyRoute: {
        KM: '#000',
        TIME: '#000',
        TOTAL: '#000',
        BAR: '#16E0CC'
    },
};

export const BLAMING_COLORS = {
    GUILTY: '#DC4C4C',
    NOT_GUILTY: '#16CCC3',
};

export const USE_CONTRACT_TYPES = {
    CREDIT: 'CREDIT',
    LEASING: 'LEASING',
    ALD: 'ALD',
    PURCHASE: 'PURCHASE',
    ALUGUER: 'ALUGUER',
    FLEX_RENT: 'FLEX_RENT',
};

export const SEGMENT_FEATURES = {
    KM: 'KM',
    FUEL: 'FUEL',
    HOURS: 'HOURS'
};

import NoImage from 'assets/img/asset-default-image.png';
export const DefaultAssetImage = NoImage;


export const date_formats = [

    'DD MM YYYY',
    'DD MM YY',

    'YYYY MM DD',
    'YY MM DD'

    // 'MM DD YYYY',
    // 'MM DD YY',
]

/**
* max size email attachemnts
*/
export const MAX_ATTACHMENT_SIZE_MB = 25;
export const MAX_ATTACHMENT_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MB * 1024 * 1024;


// export const EXPENSES_FIELDS = [{    
//     label: 'INVOICE_NUMBER',
//     key: 'invoiceNumber',    
//     alternateMatches: ['N° de facture', 'Nº Documento'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: 'FT/0001',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },   
//   {    
//     label: 'VALUE',
//     key: 'value',    
//     alternateMatches: ['Montant TTC remise/maj incl.', 'Valor Liq. Tot. c/IVA (Euros)'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: '10.95',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },   
//   {    
//     label: 'REGISTRATION',
//     key: 'registration',    
//     alternateMatches: ['Libellé estampé (immat./nom)', 'Matrícula'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: 'AA-00-00',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },
//   {    
//     label: 'DATE',
//     key: 'date',    
//     alternateMatches: ['Date de la transaction', 'Data Transacção'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: '30/06/2025',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },
//   {    
//     label: 'QUANTITY',
//     key: 'quantity',    
//     alternateMatches: ['Quantité', 'Qt Litros Abast.'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: '5',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },
//   {    
//     label: 'KMS',
//     key: 'mileage',    
//     alternateMatches: ['Kilométrage saisi', 'Kms Registados Consumo'],    
//     fieldType: {      
//       type: 'input',
//     },    
//     example: '20100',    
//     validations: [],
//   },
//   {    
//     label: 'TYPE_CODE',
//     key: 'typeCode',    
//     alternateMatches: ['Code produit (libellé)', 'Descr. Produto Frota'],    
//     fieldType: {      
//       type: 'select',
//       options: [],
//       alternateMatches: []
//     },    
//     example: '20100',    
//     validations: [ {   
//          rule: 'required',
//          errorMessage: 'Is required',
//          level: 'error',
//        },
//     ],
//   },  
// ] as const;